import { addScript } from '@tunein/web-utils';
import { onImpression, onRequest, onResponse, onView, setPubAdsConsentStatus, } from '../../../../js/ads/controllers/display/displayAdHandlers';
import { State, getState } from '../../../../js/utils/applicationState';
import logger from '../../../logging/logger';
class FreeStar {
    #readyPromise;
    constructor() {
        this.#readyPromise = Promise.withResolvers();
    }
    #setupGpt = () => {
        googletag.pubads().addEventListener('slotRequested', onRequest);
        googletag.pubads().addEventListener('slotResponseReceived', onResponse);
        googletag.pubads().addEventListener('slotRenderEnded', onImpression);
        googletag.pubads().addEventListener('impressionViewable', onView);
        googletag.pubads().setTargeting('partnerId', getState(State.partnerId));
    };
    get readyPromise() {
        return this.#readyPromise?.promise;
    }
    #onReady = async () => {
        this.#setupGpt();
        await setPubAdsConsentStatus(true);
        this.#readyPromise.resolve();
    };
    async initialize() {
        window.freestar = {
            queue: [this.#onReady],
            config: {
                channel: getState(State.config)?.targeting?.ads_partner_alias,
                enabled_slots: [],
            },
        };
        try {
            await addScript({
                src: 'https://a.pub.network/tunein-com/pubfig.min.js',
                async: true,
                attributes: {
                    'data-cfasync': false,
                },
                appendTo: 'head',
            });
            logger.debug('Initialized Freestar.');
        }
        catch (ex) {
            this.#readyPromise.resolve();
            logger.debug('Error during Freestar initialization.', ex);
        }
        return this.readyPromise;
    }
    async showAds(slots, targeting) {
        await this.readyPromise;
        if (!slots.length) {
            logger.debug('No slots passed to request to show the ad.');
            return;
        }
        let slotNames = '';
        freestar.newAdSlots(slots.map(({ name, elementId }) => {
            slotNames += name;
            return {
                placementName: name,
                slotId: elementId,
                targeting,
            };
        }));
    }
    async refreshAds(slotIds) {
        await this.readyPromise;
        freestar.refresh(slotIds);
    }
    async deleteAds(slotIds) {
        await this.readyPromise;
        freestar.deleteAdSlots(slotIds);
    }
}
export const freeStar = new FreeStar();
